export default {
    id : null,
    code : null,
    role : null,
    is_active : true,
    use_dashboard : false,
    role_access : []
}